/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-11 14:05:30
 *
 *******************************************************/
// @flow
//
import React, { Component } from 'react';
import { Layout, Heading, Button, Card } from '@shopify/polaris';
import { CSSTransition } from 'react-transition-group';
import { CaretDownMinor, CaretUpMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';
import { Link } from '@shopify/polaris';

type State = {
  active: boolean
};

class PlansQA extends Component<WithI18nProps, State> {
  state = {
    active: 0
  };

  renderQuestionsCol = (questions, startIndex) => {
    const { active } = this.state;
    return questions.map((item, index) => {
      const itemIndex = index + startIndex;

      return (
        <Card key={index}>
          <Card.Header
            title={
              <div className="BC_Card-Header">
                <Heading>{item.question}</Heading>
              </div>
            }>
            <div
              className={`BC-Block-Dismiss--Right-Menu ${
                active === itemIndex ? '' : 'rotate-icon'
              }`}>
              <Button
                icon={active === itemIndex ? CaretDownMinor : CaretUpMinor}
                plain
                onClick={e => this.toggleContent(active === itemIndex ? -1 : itemIndex)}
              />
            </div>
          </Card.Header>
          <CSSTransition
            in={active === index + startIndex}
            timeout={500}
            classNames="item-transition transition"
            unmountOnExit>
            <Card.Section>
              <div className="answer">{item.answer}</div>
            </Card.Section>
          </CSSTransition>
        </Card>
      );
    });
  };

  render() {
    const { i18n } = this.props;
    const questionsLeft = [
      {
        question: i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question01'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question01_Answer_Text01')}</p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question02'),
        answer: (
          <div>
            <p>
              {i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question02_Answer_Text01', {
                t1: (
                  <Link external url={URL['ShopifyInventory']}>
                    {i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question02_Answer_Text01_t1')}
                  </Link>
                )
              })}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question03'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question03_Answer_Text01')}</p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question04'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question04_Answer_Text01')}</p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question05'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question05_Answer_Text01')}</p>
          </div>
        )
      }
    ];

    const questionsRight = [
      {
        question: i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question06'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question06_Answer_Text01')}</p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question07'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question07_Answer_Text01')}</p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question08'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question08_Answer_Text01')}</p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question09'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.SubscriptionV4.PlansQA.question09_Answer_Text01')}</p>
          </div>
        )
      }
    ];
    return (
      <div className="subscriptionV3-questions">
        <div className="align-center card-title-uppercase title">
          <Heading>{i18n.translate('AdminHTML.SubscriptionV4.PlansQA.title')}</Heading>
        </div>
        <Layout>
          <Layout.Section oneHalf>{this.renderQuestionsCol(questionsLeft, 0)}</Layout.Section>
          <Layout.Section oneHalf>
            {this.renderQuestionsCol(questionsRight, questionsLeft.length)}
          </Layout.Section>
        </Layout>
      </div>
    );
  }

  toggleContent = index => {
    this.setState({ active: index });
  };
}

export default withI18n()(PlansQA);
